import React from 'react';
import './NonLngLatDataPanel.css';
import { nonLngLatDataType } from '../../types';

const getMarkdownLink = (text: string) => {
    const match = text.match(/^\[(.+?)\]\((https:\/\/[^\s)]+)\)$/);
    if (!match) {
        return null;
    }
    return {href: match[2], text: match[1]};
}
const NonLngLatDataPanel: React.FC<nonLngLatDataType> = ({ title, data, isShow }) => {

    if (!isShow) { return <></>; }

    return (
        <div className="nonLngLatDataPanel">
            <h3>{title.includes('/') ? title.split('/').slice(-1)[0] : title}</h3>
            <div className='non-lnglat-content'>
            {
                data ?
                    data.map((item, index) => {
                        const hasAsterisk = item.includes('※');
                        if (!hasAsterisk) {
                            const link = getMarkdownLink(item);
                            return link ? (<a key={index}
                                              href={link.href}
                                              target='_blank'
                                              rel='noopener noreferrer'>{link.text}</a>) : (
                                <p
                                    key={index}
                                    style={{ whiteSpace: 'pre-line' }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            );
                        }
                        return null;
                    })
                :
                    <p>データなし</p>
            }
            </div>
            {
                data && data.map((item, index) => {
                    const hasAsterisk = item.includes('※');
                    if (hasAsterisk) {
                        return (
                            <div 
                                key={index} 
                                className='asterisk-content'
                            >
                                <p 
                                    style={{ whiteSpace: 'pre-line' }} 
                                    dangerouslySetInnerHTML={{ __html: item }} 
                                />
                            </div>
                        );
                    }
                    return null;
                })
            }
        </div>
    );
};

export default NonLngLatDataPanel;
